import React from 'react'
import logo from "../images/logo.png";
import image8 from "../images/image8.png";
import image12 from "../images/image12.png";
import image19 from "../images/image19.png";
import image18 from "../images/image18.png";
import image17 from "../images/image17.png";
import image16 from "../images/image16.png";
import image15 from "../images/image15.png";
import image20 from "../images/image20.png";
import Header from "../component/Header";
import Footer from "../component/Footer"
function Community() {
  // const style = { width: "66px", height: "18px", position: "absolute", top: "20px", left: "20px", right: "284px", }

  return (
    <>
      <Header />

      <section className="Comm-container">

        <div className="Comm-Sub-Container1">
          {/* <a href="/Menu" className="nav">
            <div className="one"></div>
            <div className="two"></div>
            <div className="three"></div>
          </a> */}
          <div className="Comm-Sub-Container2">
            <div className="logo-con">
              <img src={logo} alt='logo-image' className="logo" />
            </div>

            <h1 className="Comm-H">Be a part of a thriving community</h1>
            <p className="Comm-P">Connect with other business owner like you on the growth journey</p>
          </div>

          <div className="Comm-Sub-Container3">
            <div className="Web-container">
              <h2 className="Web-H">Webinars</h2>
              <p className="P-menu">Learn from business experts and grow your business</p>
            </div>

            <div className="Web-container">
              <h2 className="BC-H">Business Clinic</h2>
              <p className="BC-P">One-on-one business consulting and advisory sessions with experts</p>
            </div>

            <div className="Web-container">
              <h2 className="BH-menu"> Bussiness Pitch</h2>
              <p className="B-menu">Strategic tactics necessary for the potential-client transition</p>
            </div>

            <div className="Web-container">
              <h2 className="C-H">Community</h2>
              <p className="C-Pmenu">Join a  community of business owners like you </p>
            </div>
          </div>
        </div>

        <div className="Comm-Sub-Container4">
          <h1 className="Gallary">Our Gallery</h1>

          <div className="comm-img-container">
            <img className="pic1" src={image8} alt="" />
            <img className="pic2" src={image12} alt="" />
          </div>

          <div className="comm-img-container2">
            <img className="pic3" src={image8} alt="" />
            <img className="pic4" src={image12} alt="" />
          </div>
        </div>

        <div className="Comm-Sub-Container5">
          <h1 className="OP2">Our partners</h1>

          <div className="Partner-Container">
            <img className="flutterwave2" src={image17} alt="" />
            <img className="paystack2" src={image18} alt="" />
            <img className="TechC2" src={image19} alt="" />
            <img className="Instagram2" src={image16} alt="" />
            <img className="spotify2" src={image15} alt="" />
            <img className="stripe2" src={image20} alt="" />
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}

export default Community;
